import React from 'react'
import moment from 'moment'
import styled from 'styled-components'

import { AdminRelatedLink, } from '@components'

import { Agent, } from '@types'

interface Props {
  agent: Agent
  unreadChatCount?: number
  style?: any
  onClick?: () => void
}

const Container = styled.div`
  transition: 0.3s background-color ease;

  > .row {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: rgb(221, 221, 221);
    padding: 9px 0;
    margin: 0 12px;
    align-items: flex-start;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .agent-profile-image {
    width: 56px;
    height: 56px;
    border-radius: 6px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .agent-information-container {
    margin-left: 8px;
    min-width: 0;
    flex: 1;

    .top-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px 6px;
    }

    .agent-name {
      font-size: 16px;
      font-weight: bold;
      color: rgb(85, 85, 85);
    }

    .agent-level, .agent-id {
      font-size: 12px;
      color: rgb(117, 117, 117);
    }

    .unread-chat-count {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 20px;
      height: 20px;
      padding: 0 7px;
      border-radius: 999px;
      background-color: rgb(220, 38, 38);
      color: white;
      font-size: 11px;
      font-weight: 800;
      line-height: 1;
    }

    .agent-common {
      font-size: 13px;
      color: rgb(85, 85, 85);
      margin-top: 3px;
      line-height: 1.35;

      &.location-updated-at {
        font-size: 12px;
      }

      &.compact-line {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }
`

function AgentSummary(props: Props) {
  const { agent, unreadChatCount = 0, style, onClick, } = props

  const renderWorkingStatus = () => {
    if(agent.is_working) {
      return `${ moment(agent.agent_location.updated_at).fromNow() } 업데이트`
    } else {
      return <b>업무종료</b>
    }
  }

  return (
    <Container style={ style } onClick={ onClick }>
      <div className='row'>
        <img
          src={ agent.agent_profile.profile_image }
          className='agent-profile-image'
        />
        <div className='agent-information-container'>
          <div className='top-row'>
            <span className='agent-name'>{ agent.name }</span>
            <span className='agent-level'>{ agent.agent_profile.level }레벨</span>
            <span className='agent-id'>(사번: { agent.agent_profile.id })</span>
            {
              unreadChatCount > 0 && (
                <span className='unread-chat-count'>
                  채팅 { unreadChatCount > 99 ? '99+' : unreadChatCount }
                </span>
              )
            }
          </div>
          <div className='row'>
            <span className='agent-common'>
              <AdminRelatedLink linkType='phoneCall' id={ agent.mobile_number }>{ agent.mobile_number }</AdminRelatedLink> ({ renderWorkingStatus() })
            </span>
          </div>
          <div className='row'>
            <span
              className='agent-common compact-line'
              title={ `희망 도착지: ${ agent.agent_location.desired_destination_address || '없음' }` }>
              희망 도착지: { agent.agent_location.desired_destination_address || '없음' }
            </span>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default AgentSummary
